import React from "react";

const DoubleTick = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M17.496 20.507l2.064 2.088 12.373-12.52L34 12.166 19.56 26.778l-9.302-9.412 2.067-2.091 3.106 3.143 2.065 2.088v.001zm.003-4.182L24.737 9l2.06 2.085-7.238 7.325-2.06-2.085zm-4.132 8.363l-2.066 2.09L2 17.366l2.067-2.091 2.065 2.09-.002.001 7.237 7.322z"
            fill={fill}
        />
    </svg>
);

export default DoubleTick;
